import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import AWS from 'aws-sdk';
import Papa from 'papaparse';
import { fileNamePatternFileType, fileNamePatternSentiment, fileNamePatternIntent } from '../data/dummy';

const S3FileRequest = forwardRef((props, ref) => {

    

    const s3 = new AWS.S3({
        region: process.env.REACT_APP_AWS_REGION,
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    });

    const bucketName = process.env.REACT_APP_S3_BUCKET;
    const [keywordFreqData, setKeywordFreqData] = useState({});
    const [unixTime, setUnixTime] = useState('');
    const [userId, setUserId] = useState('');

    // CSV 파일들을 병렬로 가져오는 함수
    const handleDownloadCSV = async () => {
        const files = fileNamePatternFileType.flatMap(item1 => 
            fileNamePatternSentiment.flatMap(item2 =>
              fileNamePatternIntent.map(item3 => 
                `${item1}_${item2}_${item3}_${unixTime}.csv`
              )
            )
          );
        console.log(`files: ${files}`);
        try {
            const csvPromises = files.map((fileName) => fetchCSV(fileName)); // 각 파일을 비동기적으로 가져옵니다
            const csvData = await Promise.all(csvPromises); // 모든 CSV 파일을 병렬로 가져옵니다

            // 각 CSV 파일에서 데이터 추출 및 파일별로 다른 변수에 저장
            const newKeywordsData = csvData.reduce((acc, data, index) => {
                const fileName = files[index].split('.')[0];  // 파일 이름을 키로 사용
                acc[fileName] = data;  // 키를 파일 이름으로 설정하여 각 파일 데이터를 저장
                return acc;
            }, {});

            setKeywordFreqData(newKeywordsData); // 결과를 상태에 저장
            localStorage.setItem('keywordFreqData', newKeywordsData);
        } catch (error) {
            console.error('Error downloading CSV files:', error);
        }
    };

    // 부모 컴포넌트에서 사용할 수 있도록 함수를 노출
    useImperativeHandle(ref, () => ({
        handleDownloadCSV,
    }));

    // CSV 파일을 가져오는 함수
    const fetchCSV = async (fileName) => {
        try {
            console.log(`fileName: ${fileName}`);
            
            if (!bucketName) {
                console.error('S3 버킷 이름이 정의되지 않았습니다!');
                return [];
            }

            const params = {
                Bucket: bucketName,
                Key: `00000000000/output_file/${fileName}`, // 정확한 파일 경로
            };

            const data = await s3.getObject(params).promise();
            const csvContent = data.Body.toString('utf-8');  // S3에서 받은 파일을 UTF-8로 변환

            // CSV 파일을 파싱하여 { text, value } 객체의 배열로 변환
            const parsedData = Papa.parse(csvContent, { header: true, skipEmptyLines: true }).data;
            console.log(parsedData); // 디버깅용 출력

            // 파싱된 데이터를 반환
            return parsedData;

        } catch (error) {
            console.error(`CSV 파일 ${fileName}을 가져오는 중 오류 발생:`, error);
            return []; // 오류 발생 시 빈 배열 반환
        }
    };

    useEffect(() => {
        const storedUserID = localStorage.getItem('userId');
        setUserId(storedUserID || '');
        console.log(`storedUserID: ${storedUserID}`);
    
        const storedUnixTime = localStorage.getItem('unixTime');
        setUnixTime(storedUnixTime || '');
        console.log(`storedUnixTime: ${storedUnixTime}`);
    }, [])

    return (
        <div>
            {/* <button onClick={handleDownloadCSV}>Download and Parse CSV Files</button>

            {Object.keys(keywordFreqData).length > 0 && (
                <div>
                    <h3>Keywords for WordCloud:</h3>
                    {Object.keys(keywordFreqData).map((fileName, index) => (
                        <div key={index}>
                            <h4>{fileName}</h4>
                            <ul>
                                {Array.isArray(keywordFreqData[fileName]) && keywordFreqData[fileName].map((item, index) => (
                                    <li key={index}>
                                        {item.word}: {item.count}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            )} */}
        </div>
    );
});

export default S3FileRequest;
